import { usePersistingActor } from '@ui-common/hooks/usePersistingActor'
import { createContext, JSX, ReactNode, useMemo } from 'react'
import { ActorRefFrom } from 'xstate'

import { OnAutomaticOfferData } from '../loan-offer/types'
import { createWizardMachine, initialSecLoansWizardContext, WizardContext } from '../wizard/wizardMachine'

interface ApplicationWizardContext {
  service: ActorRefFrom<ReturnType<typeof createWizardMachine>>
}

export const ApplicationWizardContext = createContext<ApplicationWizardContext>({} as ApplicationWizardContext)

interface Props {
  children: ReactNode
  initialContext?: Partial<WizardContext>
  onGoToCatalog: () => void
  onNewApplicationClick: () => void
  onAutomaticOfferResponse: (data: OnAutomaticOfferData) => void
}

export const ApplicationWizardProvider = ({
  children,
  initialContext,
  onGoToCatalog,
  onNewApplicationClick,
  onAutomaticOfferResponse,
}: Props): JSX.Element => {
  const wizardMachine = createWizardMachine({ onGoToCatalog, onNewApplicationClick, onAutomaticOfferResponse })
  const service = usePersistingActor(wizardMachine, undefined, undefined, {
    ...initialSecLoansWizardContext,
    ...initialContext,
  })
  const context = useMemo(() => ({ service }), [service])
  return <ApplicationWizardContext value={context}>{children}</ApplicationWizardContext>
}
